import { useEffect } from 'react';

export const EDITOR_CLICK_EVENT = 'rte-editor-click';

export const dispatchEditorClickEvent = () => {
  document.dispatchEvent(new CustomEvent(EDITOR_CLICK_EVENT));
};

const useCloseOnEditorClick = (isOpen: boolean, onClose: () => void) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleEditorClick = () => {
      onClose();
    };

    document.addEventListener(EDITOR_CLICK_EVENT, handleEditorClick);
    return () => document.removeEventListener(EDITOR_CLICK_EVENT, handleEditorClick);
  }, [isOpen, onClose]);
};

export default useCloseOnEditorClick;
